import { Component, Input } from '@angular/core';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { FilterService, BaseFilterCellComponent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'entitystate-filter',
    templateUrl: './entitystate-filter.component.html',
})
export class EntityStateFilterComponent extends BaseFilterCellComponent {

    @Input()
    public filter: CompositeFilterDescriptor;

    public data: any[] = [
		{ Id: 1, Name: "Активный" },
		{ Id: 2, Name: "Архив" }
	];

    public get defaultItem(): any {
        return {
            Id: null,
            Name: '(Все)'
        };
    }

    public get selectedValue(): any {
        const filter = this.filterByField("entityStatus");
        return filter ? filter.value : null;
    }

    constructor(filterService: FilterService) {
        super(filterService);
    }

    public onChange(value: any): void {
        this.applyFilter(
            value === null ? // value of the default item
                this.removeFilter("entityStatus") : // remove the filter
                this.updateFilter({ // add a filter for the field with the value
                    field: "entityStatus",
                    operator: 'eq',
                    value: value
                })
        ); // update the root filter
    }
}
